import React from "react";
import CountUp from "react-countup";
import Speciality from "../Components/Home_Components/Speciality";
import NewLaunch from "../Components/Home_Components/NewLaunch";
import WhyChooseUs from "../Components/Home_Components/WhyChooseUS";
import Hero from "../Components/Home_Components/Hero";
import Blog from "../Components/Home_Components/Blog";
import ContactSection from "../Components/Home_Components/ContactSection";
import PremiumPicks from "../Components/Home_Components/PremiumPicks";
import OurHustle from "../Components/Home_Components/OurHustle";
import PropertySectionv from "../Components/Home_Components/PropertySectionv";
import PromoBannor from "../Components/Home_Components/PromoBannor";
import MediaUpdates from "../Components/Home_Components/MediaUpdates";
import StatsSection from '../Components/Home_Components/StatsSection';
import ExcellenceSection from '../Components/Home_Components/ExcellenceSection';
import Testimonials from '../Components/Home_Components/Testimonials';


const Home = () => {
    return (
        <>
            {/* <div className="big-house-home-container">
                <div className="big-house-home-left">
                    <h1 className="big-house-home-heading">
                        Discover Your Dream Home with Bighouse Advisory
                    </h1>
                    <p className="big-house-home-subtext">
                        Explore the finest properties in prime locations—from luxurious apartments to expansive homes.
                    </p>
                    */}
                    {/* <button className="big-house-home-btn">Browse Now</button> */}

                   {/* <div className="big-house-home-counters">
                        <div className="big-house-counter-box">
                            <h3>
                                <CountUp end={100} duration={2} enableScrollSpy />+
                            </h3>
                            <p>Premium Projects</p>
                        </div>
                        <div className="big-house-counter-box">
                            <h3>
                                <CountUp end={50} duration={2} enableScrollSpy />+
                            </h3>
                            <p>Expert Consultant Team</p>
                        </div>
                    </div>
                </div>

                <div className="big-house-home-right">
                   <img src={LandingImg} alt="" />
                </div>
            </div> */}
            <Hero />
            <PremiumPicks />
            {/* <NewLaunch /> */}
            <OurHustle />
            <PropertySectionv />
            <PromoBannor />
             {/* {*<MediaUpdates />*} */}
             <StatsSection />
             {/* <ExcellenceSection /> */}
             {/* <Testimonials /> */}
            <Speciality />
            <WhyChooseUs />
            {/* <Blog /> */}
            <ContactSection />
        </>
    );
};

export default Home;
